import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * @component
 * @name Toast
 * @description It's the in-app message appears upon getting an error,
 * typically at the bottom right corner.
 */
class Toast extends Component {
  state = {
    // Message will be shown for this much of time
    timeinms: 5000, //unit: milliseconds
  };

  componentDidMount = () => {
    this.init(this.props);
  };

  // show toast message
  init = (props) => {
    props.message.trim() !== '' &&
      toast(props.message, {
        type: toast.TYPE.INFO,
        onClose: () => this.reset(),
      });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.message !== this.props.message) {
      nextProps.message.trim() !== '' && this.init(nextProps);
    }
  }

  // clear error message and loading
  reset() {
    this.props.updateErrorAndLoading(undefined, undefined);
  }
  render() {
    return (
      <div onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        <ToastContainer
          position="bottom-right"
          autoClose={this.state.timeinms}
          pauseOnHover
          pauseOnVisibilityChange={false}
          hideProgressBar={false}
          newestOnTop={false}
          rtl={false}
          draggable
        ></ToastContainer>
      </div>
    );
  }
}

Toast.propTypes = {
  /**
   * Global error message
   */
  message: PropTypes.string,
  /**
   * Whether an API request is in progress
   */
  loading: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    message: state.route.errorMessage,
    loading: state.route.loading,
    // primaryColor: state.code_config.primaryColor,
    // secondaryColor: state.code_config.secondaryColor,
  };
};

export default connect(mapStateToProps, actions)(Toast);
